import { useCallback } from "react";
import { useNotificationContext } from "context/NotificationContext";

export default function useNotify() {
  const context = useNotificationContext();
  const notify = useCallback(
    (message, variant = "info") => {
      context?.notify(message, variant);
    },
    [context]
  );

  const notifySuccess = useCallback((message) => notify(message, "success"), [notify]);
  const notifyError = useCallback((message) => notify(message, "error"), [notify]);
  const notifyInfo = useCallback((message) => notify(message, "info"), [notify]);
  const notifyWarning = useCallback((message) => notify(message, "warning"), [notify]);

  return { notify, notifySuccess, notifyError, notifyInfo, notifyWarning };
}
